import { Download } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";
import React from "react";

interface ContextMenuProps {
  position: { x: number; y: number };
  onClose: () => void;
  onDownload: () => void;
  onDownloadOriginal: () => void;
}

export function ContextMenu(props: ContextMenuProps) {
  const { position, onClose, onDownload, onDownloadOriginal } = props;
  React.useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest(".context-menu")) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  return (
    <Menu
      open
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={{ top: position.y, left: position.x }}
      onContextMenu={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        // This is important to avoid transfer a click event when the user do a click outside the menu
        e.preventDefault();
        e.stopPropagation();
      }}
      className="context-menu"
      MenuListProps={{ className: "p-0" }}
    >
      <MenuItem onClick={onDownloadOriginal}>
        <Download fontSize="small" /> Download Original Image
      </MenuItem>
      <MenuItem onClick={onDownload}>
        <Download fontSize="small" /> Download Annotated Image
      </MenuItem>
    </Menu>
  );
}
